import { apiClient } from '../api';
import type { ApiResponse } from '@/types/auth';
import type { BillPlan, BillProduct } from '@/types/bills';

class AdminBillsService {
  listProducts(category?: string) {
    return apiClient.get<ApiResponse<{ products: BillProduct[] }>>('/admins/bills/products', {
      params: category ? { category } : undefined,
    });
  }

  updateProduct(
    id: number,
    payload: Partial<{
      providerDiscount: number;
      subscriberDiscount: number;
      agentDiscount: number;
      providerCommissionCap: number | null;
      agentCommissionCap: number | null;
      providerCommissionFixed: number;
      agentCommissionFixed: number;
      isActive: boolean;
    }>,
  ) {
    return apiClient.put<ApiResponse<{ product: BillProduct }>>(
      `/admins/bills/products/${id}`,
      payload,
    );
  }

  syncPlans(productId: number) {
    return apiClient.post<ApiResponse<{ plans: BillPlan[] }>>(
      `/admins/bills/products/${productId}/sync-plans`,
    );
  }

  listPlans(productId: number) {
    return apiClient.get<ApiResponse<{ plans: BillPlan[] }>>('/admins/bills/plans', {
      params: { productId },
    });
  }

  updatePlan(
    id: number,
    payload: Partial<{ subscriberPrice: number; agentPrice: number; isActive: boolean }>,
  ) {
    return apiClient.put<ApiResponse<{ plan: BillPlan }>>(`/admins/bills/plans/${id}`, payload);
  }
}

export const adminBillsService = new AdminBillsService();
